import { useEffect, useRef, useState } from 'react'
import dayjs from 'dayjs'
import {
  FULL_CALENDAR_VIEW_TYPES,
  getDayjsDateFromFullCalendarDateString,
  getFullCalendarConvertedDateFromDayJsDate,
} from 'src/supportPortal/components/common/roster/utils'

export const useCalendarState = (initialDate, minDate, maxDate, lockedDates) => {
  const calendarRef = useRef(null)
  const [currentDate, setCurrentDate] = useState(dayjs())
  const [toDate, setToDate] = useState(initialDate || dayjs())
  const [currentView, setCurrentView] = useState(FULL_CALENDAR_VIEW_TYPES.dayView)

  const handleChangeDate = (muiDate) => {
    // Check if date is locked

    if (lockedDates && !isDateSelectable(muiDate, minDate, maxDate, lockedDates)) {
      return
    }
    setCurrentDate(muiDate)
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi()
      const fcDate = getFullCalendarConvertedDateFromDayJsDate(muiDate)
      calendarApi.gotoDate(fcDate)
    }
  }

  const isDateSelectable = (date, min, max, locked) => {
    if (min && dayjs(date).isBefore(dayjs(min))) return false
    if (max && dayjs(date).isAfter(dayjs(max))) return false
    if (locked && locked.some((lockedDate) => dayjs(date).isSame(lockedDate, 'day'))) return false
    return true
  }

  const handleFullCalendarDateChange = ({ from, to, viewType }) => {
    setCurrentDate(getDayjsDateFromFullCalendarDateString(from))
    setToDate(getDayjsDateFromFullCalendarDateString(to))
    setCurrentView(viewType)
  }

  const updateSelectedSlot = ({ date, startTime, endTime }) => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi()
      const startDateTime = `${date}T${startTime}:00`
      const endDateTime = `${date}T${endTime}:59`
      calendarApi.select(startDateTime, endDateTime)
    }
  }

  const unselectSlot = () => {
    calendarRef.current?.getApi()?.unselect()
  }

  useEffect(() => {
    if (initialDate) {
      handleChangeDate(initialDate)
      setToDate(initialDate)
    }
  }, [initialDate])


  return {
    calendarRef,
    currentDate,
    toDate,
    currentView,
    handleChangeDate,
    handleFullCalendarDateChange,
    updateSelectedSlot,
    unselectSlot,
    isDateSelectable,
  }
}
